import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import { AuthLayout } from '../../Layout';
import { Button, Heading, ProgressBar } from '../../Components/Atoms';
import CheckboxGroup from './CheckboxGroup';
import api from '../../Util/api';
import { useHistory } from 'react-router';

const Step4 = () => {
  const nextStep = () => history.push('/t/signup/step-5');
  const [tools, setTools] = useState();
  const [otherInputValue, setOtherInputValue] = useState('');
  const history = useHistory();

  const getTools = () => {
    api.general
      .getTools()
      .then((response) => {
        if (response.status === 200) {
          setTools(response.data.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  useEffect(() => {
    getTools();
  }, []);

  const handleOnSubmit = (values) => {
    updateTools(values);
  };

  const updateTools = (values) => {
    values.checked.forEach((option) => {
      api.therapist
        .updateTools(option)
        .then((response) => {
          if (option === '15') {
            if (otherInputValue) api.therapist.setOtherToolsOrSpecialisms({ tool: otherInputValue });
          }
          return response.data;
        })
        .then((result) => {
          console.log(result);
        })
        .catch((error) => console.log('error', error));
    });

    nextStep();
  };

  const otherInputOnChange = (e) => setOtherInputValue(e.target.value);

  return (
    <>
      <AuthLayout>
        <>
          <Heading>What are the different types of therapy that you offer?</Heading>
          <ProgressBar progress="40" style={{ margin: '20px auto', maxWidth: '500px' }} />
          <p>
            Your chosen therapy tools will help us to match you with the most relevant patients. Please select all that
            apply.
          </p>
          <Formik
            initialValues={{
              checked: [],
            }}
            onSubmit={handleOnSubmit}
          >
            {({ values }) => (
              <Form>
                {tools && <CheckboxGroup values={values} options={tools} otherInputOnChange={otherInputOnChange} />}

                <ButtonWrapper>
                  <Button variant="muted" onClick={nextStep}>
                    Skip
                  </Button>
                  <Button variant="primary" type="submit">
                    Continue
                  </Button>
                </ButtonWrapper>
              </Form>
            )}
          </Formik>
        </>
      </AuthLayout>
    </>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 32px;
  }
`;

export default Step4;
